var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLupa({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.3269 15.04L17.8 18.4M8.8 5.19998C10.7882 5.19998 12.4 6.81175 12.4 8.79998M16.68 9.43998C16.68 13.7699 13.1699 17.28 8.84 17.28C4.51009 17.28 1 13.7699 1 9.43998C1 5.11006 4.51009 1.59998 8.84 1.59998C13.1699 1.59998 16.68 5.11006 16.68 9.43998Z",
    stroke: "#B0BBD5",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLupa);
export default __webpack_public_path__ + "static/media/lupa.577ffd5d90b3f82de7394325d2e87a71.svg";
export { ForwardRef as ReactComponent };